import '@fontsource/lato/400.css'; // Poids 400
// import '@fontsource/lato/500.css'; // Poids 500
// import '@fontsource/lato/600.css'; // Poids 600
import '@fontsource/lato/700.css'; // Poids 700
import '@fontsource/lato/900.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { AnalyticsProvider } from './src/analytics/context/AnalyticsContext'; // Poids 900
import { IntlProvider } from './src/common/intl/components/IntlProvider';
import { defaultLocale } from './src/common/navigation/types/config';
import './src/style/global.css';
import { LOCAL_STORAGE_LANG_KEY } from './src/utils/redirectToPreferredLanguage';

export const wrapPageElement = ({ element }) => {
  let initialLocale = defaultLocale;
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    const storedLocale = localStorage.getItem(LOCAL_STORAGE_LANG_KEY);
    if (storedLocale) {
      initialLocale = storedLocale;
    }
  }

  return (
    <IntlProvider defaultLocale={initialLocale}>
      <AnalyticsProvider>
        <AnimatePresence initial={false}>
          <div style={{ minWidth: `390px` }}>{element}</div>
        </AnimatePresence>
      </AnalyticsProvider>
    </IntlProvider>
  );
};
